import en from '@/assets/i18n/en.json';
import es from '@/assets/i18n/es.json';
import it from '@/assets/i18n/it.json';
import de from '@/assets/i18n/de.json';
import fr from '@/assets/i18n/fr.json';
import kr from '@/assets/i18n/kr.json';
import jp from '@/assets/i18n/jp.json';
import chs from '@/assets/i18n/chs.json';

const t = {
  en,
  es,
  it,
  de,
  fr,
  kr,
  jp,
  chs,
};

const translate = (key, lang) => t[lang] ? (t[lang][key] || 'NO_LABEL') : 'NO_LANG'; // eslint-disable-line

export default translate;
